"use strict";

require("core-js/modules/es6.string.fixed");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var asset_accessor_1 = require("../asset-accessor");

var util_1 = require("../util");

var ContentfulAssetAccessor =
/** @class */
function () {
  function ContentfulAssetAccessor(base) {
    this.base = base;
  }

  Object.defineProperty(ContentfulAssetAccessor.prototype, "fileUrl", {
    get: function get() {
      var _a, _b, _c;

      return (_c = (_b = (_a = this.base) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.file) === null || _c === void 0 ? void 0 : _c.url;
    },
    enumerable: true,
    configurable: true
  });

  ContentfulAssetAccessor.prototype.url = function (defaultValue) {
    var _a;

    return _a = this.fileUrl, _a !== null && _a !== void 0 ? _a : defaultValue;
  };

  ContentfulAssetAccessor.prototype.fluid = function (opts) {
    var _a, _b, _c, _d, _e, _f, _g;

    var url = this.fileUrl;
    var imageDetails = (_d = (_c = (_b = (_a = this.base) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.file) === null || _c === void 0 ? void 0 : _c.details) === null || _d === void 0 ? void 0 : _d.image;

    if (url) {
      var returnObject = {
        base64: undefined,
        tracedSVG: undefined,
        aspectRatio: imageDetails && imageDetails.width / imageDetails.height,
        src: url,
        srcSet: undefined,
        srcWebp: undefined,
        srcSetWebp: undefined,
        sizes: undefined,
        presentationWidth: imageDetails && imageDetails.width,
        presentationHeight: imageDetails && imageDetails.height
      };

      if (((_g = (_f = (_e = this.base) === null || _e === void 0 ? void 0 : _e.fields) === null || _f === void 0 ? void 0 : _f.file) === null || _g === void 0 ? void 0 : _g.contentType) !== 'image/svg+xml') {
        returnObject.srcSet = util_1.generateSrcSet(url, imageDetails && imageDetails.width);
      }

      return returnObject;
    }

    return util_1.createFallbackFluidImageObject(opts && opts.fallbackImage);
  };

  ContentfulAssetAccessor.prototype.fixed = function (opts) {
    var _a, _b, _c, _d;

    var url = this.fileUrl;
    var imageDetails = (_d = (_c = (_b = (_a = this.base) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.file) === null || _c === void 0 ? void 0 : _c.details) === null || _d === void 0 ? void 0 : _d.image;

    if (url) {
      return {
        base64: undefined,
        tracedSVG: undefined,
        aspectRatio: imageDetails && imageDetails.width / imageDetails.height,
        src: url,
        srcSet: util_1.generateSrcSet(url, imageDetails && imageDetails.width),
        srcWebp: undefined,
        srcSetWebp: undefined,
        width: imageDetails && imageDetails.width,
        height: imageDetails && imageDetails.height
      };
    }

    return util_1.createFallbackFixedImageObject(opts && opts.fallbackImage);
  };

  ContentfulAssetAccessor.prototype.title = function () {
    var _a, _b, _c;

    return _c = (_b = (_a = this.base) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.title, _c !== null && _c !== void 0 ? _c : undefined;
  };

  ContentfulAssetAccessor.prototype.type = function () {
    var _a, _b, _c;

    if ((_c = (_b = (_a = this.base) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.file) === null || _c === void 0 ? void 0 : _c.contentType) {
      return util_1.getAssetTypeFromMimeType(this.base.fields.file.contentType);
    }

    return asset_accessor_1.CommonAccessorType.UNDEFINED;
  };

  return ContentfulAssetAccessor;
}();

exports.ContentfulAssetAccessor = ContentfulAssetAccessor;